import { refreshPage } from "./helpers/refreshPage";

export default async function handleBasketEvent(event) {
  if (event === "orderCreated") {
    window.location.href = InpostIziJavsscriptWoocommerce.thank_you_url;
    return Promise.resolve(true);
  }

  if (event === "basketProductChanged") {
    if (
      InpostIziJavsscriptWoocommerce.force_wc_fragments_refresh_after_basket_update &&
      window.jQuery &&
      typeof wc_cart_fragments_params !== 'undefined'
    ) {
      const url = wc_cart_fragments_params.wc_ajax_url
        .toString()
        .replace('%%endpoint%%', 'get_refreshed_fragments');
      window.jQuery.ajax({
        url,
        type: 'POST',
        data: { time: new Date().getTime() },
        timeout: 10000,
      }).always(function () {
        refreshPage();
      });
      return Promise.resolve(true);
    }
    refreshPage();
    return Promise.resolve(true);
  }

  if (event === "basketDeleted") {
    return Promise.resolve(true);
  }
}
